<ngx-loading-bar [includeSpinner]="false" height="4px" color="#FF0000"></ngx-loading-bar>
<div class="pages">
  <div data-page="blog" class="page no-toolbar no-navbar">
    <div class="page-content">
      <div class="navbarpages" [ngStyle]="{'min-height': debug ? '500px' : '0px', 'z-index': debug ? '99' : '10', 'overflow-y': debug ? 'scroll': 'hidden'}" >
        <div class="navbar_left">
          <a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"/></a>
        </div>
        <div class="navbar_center">
          <!--<h2>{{ this.Ueberschrift }}</h2>--><br>

          <input style="position: fixed; top:5px;left: 20%; width: 60%; height: 25px;" type="text" class="form-control" placeholder="Filter (min. 2 Zeichen)" [(ngModel)]="filter"
            (keyup)='filterPocsag()'><br>
            <div (dblclick)="debugmodetoggle();" style="margin-top: -10px; color: #fff;">
              <h3><a>Stand: {{ letzteAktualisierung }} Uhr</a></h3>
            </div>
            @if (debug) {
              <div style="color: grey" [innerHTML]="debug_txt">                    </div>
            }
          </div>
          <div class="navbar_right"><a [routerLink]="['/user']" data-panel="right" class="open-panel"><img
          src="./assets/images/icons/blue/user.png" alt="" title=""/></a></div>
        </div>
        @if (neueMeldung) {
          <div (click)="onNeueMeldung()" id="container">
            <div id="centered" (click)="onNeueMeldung()"> Neue Meldungen</div>
          </div>
        }
        <div  #hash_PocsagItems id="pages_maincontent" style="background-color: #2d2e3e;">

          @for (item of PocsagItems; track item) {
            <div #pocsag_items id="pocsag_{{item.id}}" (click)="onSelectItem(item.uid)" class="panel_pocsag"
                     [ngClass]="{
                      'schriftgross': this.schriftgross == true,
                                'gesamt-0': item.farbe[0] == '0',
                                'gesamt-1': item.farbe[0] == '1',
                                'gesamt-2': item.farbe[0] == '2',
                                'gesamt-3': item.farbe[0] == '3',
                                'gesamt-4': item.farbe[0] == '4',
                                'gesamt-5': item.farbe[0] == '5',
                                'gesamt-6': item.farbe[0] == '6',
                                'gesamt-7': item.farbe[0] == '7',
                                'gesamt-8': item.farbe[0] == '8',
                                'gesamt-9': item.farbe[0] == '9',
                                'gesamt-10': item.farbe[0] == '10',
                                'gesamt-11': item.farbe[0] == '11',
                                'gesamt-12': item.farbe[0] == '12',
                                'gesamt-13': item.farbe[0] == '13',
                                'gesamt-14': item.farbe[0] == '14',
                                'gesamt-15': item.farbe[0] == '15',
                                'gesamt-16': item.farbe[0] == '16',




                                'gesamt-17': item.farbe[0] == '17'}"
              >
            @for (zeit of item.zeit ; track $index; let i = $index) {
              <div
                         [ngClass]="{'schriftgross': this.schriftgross == true,
                                'eintrag-0': item.farbe[i] == '0' && i > 0,
                                'eintrag-1': item.farbe[i] == '1' && i > 0,
                                'eintrag-2': item.farbe[i] == '2' && i > 0,
                                'eintrag-3': item.farbe[i] == '3' && i > 0,
                                'eintrag-4': item.farbe[i] == '4' && i > 0,
                                'eintrag-5': item.farbe[i] == '5' && i > 0,
                                'eintrag-6': item.farbe[i] == '6' && i > 0,
                                'eintrag-7': item.farbe[i] == '7' && i > 0,
                                'eintrag-8': item.farbe[i] == '8' && i > 0,
                                'eintrag-9': item.farbe[i] == '9' && i > 0,
                                'eintrag-10': item.farbe[i] == '10' && i > 0,
                                'eintrag-11': item.farbe[i] == '11' && i > 0,
                                'eintrag-12': item.farbe[i] == '12' && i > 0,
                                'eintrag-13': item.farbe[i] == '13' && i > 0,
                                'eintrag-14': item.farbe[i] == '14' && i > 0,
                                'eintrag-15': item.farbe[i] == '15' && i > 0,



                                'eintrag-17': item.farbe[i] == '17' && i > 0}"
                    >
                        <div class="panel-heading panel-heading-right" [ngClass]="{'schriftgross': this.schriftgross == true}" >{{ zeit }}</div>
                        <div class="panel-heading panel-heading-left" [ngClass]="{'schriftgross': this.schriftgross == true}">@if (item.icon !== '') {
<img [src]='item.icon' width="15px" >
}&nbsp;{{ item.bezeichnung[i] }}</div>
                    </div>
}
                    @if (item.nachricht != '') {
<div class="footer">{{ item.nachricht }}</div>
}
                </div>
}
            </div>
        </div>
    </div>
</div>
